export default {
  abbrApiTrafficManager: 'https://abbreviation-1-3.loadbalancer.dicta.org.il',
  nakdanApiTrafficManager: 'https://nakdan-3-1.loadbalancer.dicta.org.il',
  citationApiTrafficManager: 'https://talmudfinder-1-2x.loadbalancer.dicta.org.il/TalmudFinder',
  bibleApiTrafficManager: 'https://tanach-search-2-3.loadbalancer.dicta.org.il',
  transliterateApiTrafficManager: '/transliterate',
  parallelApiTrafficManager: 'https://parallels-2-1.loadbalancer.dicta.org.il', // note NO "path" here
  synopsisApiTrafficManager: 'https://synopsis-2-3-alt.loadbalancer.dicta.org.il/synopsis'
}
